<nz-modal [(nzVisible)]="deleteModal" (nzOnCancel)="deleteModal = false" (nzOnOk)="onDelete()"
  [nzTitle]="'common_deletion' | translate" [nzContent]="'common_delete-one' | translate" [nzOkLoading]="deleting">
</nz-modal>
<form nz-form class="audio-form w-100" *ngIf="form" [formGroup]="form" [nzAutoTips]="explainErrorsService.autoTips">
  <nz-affix>
    <div class="py-4 border-bottom bg-white">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex align-items-center justify-content-between">
            <!-- Title -->
            <div>
              <h1 class="mb-0">
                <span *ngIf="audio.isNew()">{{
									'audio_create-form-title' | translate
								}}</span>
                <span *ngIf="!audio.isNew()">{{
									audio.getLabel()
								}}</span>
              </h1>
              <small *ngIf="!audio.isNew()" class="text-black-50">{{
									'common_id'
										| translate: { id: audio.getId() }
								}}</small>
            </div>
            <!-- /Title -->

            <!-- Actions -->
            <div>
              <button nz-button [disabled]="form.invalid" [nzLoading]="saving" nzType="primary" (click)="onSubmit()"
                *appRestrictedByScope="{
									model: 'audio',
									action: 'update'
								}">
                {{ 'common_save' | translate }}
              </button>
              <ng-container *appRestrictedByScope="{
									model: 'audio',
									action: 'delete'
								}">
                <button *ngIf="!audio.isNew() && deletable" class="ml-4" nz-button nzShape="circle"
                  [title]="'common_delete' | translate" [nzLoading]="deleting" (click)="deleteModal = true"
                  type="button">
                  <i nz-icon nzType="delete"></i>
                </button>
              </ng-container>
            </div>
            <!-- /Actions -->
          </div>
        </div>
      </div>
    </div>
  </nz-affix>
  <div class="container">
    <nz-card class="round-border my-5">
      <div *ngIf="loading" class="row">
        <div class="col-12">
          <nz-skeleton class="no-header" [nzActive]="true"></nz-skeleton>
        </div>
      </div>
      <div *ngIf="!loading">
        <div class="row" *ngIf="!readOnly">
          <div class="col-12 col-md-6">
            <!-- Name -->
            <nz-form-item>
              <h4>{{ 'audio_name' | translate }}</h4>
              <nz-form-control>
                <input nz-input class="w-100" type="text" [placeholder]="
										'common_value-string' | translate
									" formControlName="name" />
              </nz-form-control>
            </nz-form-item>
            <!-- /Name -->
          </div>
          <div class="col-12 col-md-6">
            <!-- Lang -->
            <nz-form-item>
              <h4>{{ 'audio_lang' | translate }}</h4>
              <nz-form-control [nzValidateStatus]="form.get('lang')">
                <hpf-language-select [controlName]="'lang'" [formGroup]="form" [quickFormEnabled]="quickFormEnabled"
                  [(model)]="audio.props.lang" [nullable]="true" [filterEnabled]="true" [placeholder]="
										'language_common_search-placeholder'
											| translate
									" [emptyLabel]="'common_empty' | translate">
                </hpf-language-select>
              </nz-form-control>
            </nz-form-item>
            <!-- /Lang -->
          </div>
          <div class="col-12 col-md-6 d-flex align-items-center">
            <h4>{{ 'audio_common_name' | translate }}</h4>
            <!-- Uri -->
            <input type="file" name="fileUpload" (input)="fileUploaded($event)" id="fileUpload" class="form-control">
            <!-- /Uri -->
          </div>
        </div>

        <nz-divider *ngIf="!audio.isNew() && !readOnly"></nz-divider>
        <div *ngIf="!audio.isNew()" class="row">
          <div class="col-12 col-md-6">
            <!-- _Id -->
            <div class="mb-4">
              <h4>{{ 'audio_-id' | translate }}</h4>
              <div>{{ audio.props._id }}</div>
            </div>
            <!-- /_Id -->
          </div>
          <div class="col-12 col-md-6">
            <!-- Created At -->
            <div class="mb-4">
              <h4>{{ 'audio_created-at' | translate }}</h4>
              <div>
                {{ audio.props.created_at | date: 'medium' }}
              </div>
            </div>
            <!-- /Created At -->
          </div>
          <div class="col-12 col-md-6">
            <!-- Owner -->
            <div class="mb-4">
              <h4>{{ 'audio_owner' | translate }}</h4>
              <div *ngIf="audio.ownerExists()">
                <a [routerLink]="[
										'/user',
										audio.props.owner.getId()
									]">
                  {{ audio.props.owner.getLabel() }}
                </a>
              </div>
            </div>
            <!-- /Owner -->
          </div>
          <div class="col-12 col-md-6">
            <!-- Uri -->
            <div class="mb-4">
              <h4>{{ 'audio_uri' | translate }}</h4>
              <a [href]="audio.getUri()">{{ audio.getUri() }}</a>
            </div>
            <!-- /Uri -->
          </div>
          <div class="col-12 col-md-6">
            <!-- Media preview -->
            <div class="mb-4">
              <h4>{{ 'audio_preview' | translate }}</h4>
              <audio controls>
                <source src="{{audio.getUri()}}">
                Your browser does not support the audio element.
              </audio>
            </div>
            <!-- /Media preview -->
          </div>
          <div class="col-12 col-md-6" *ngIf="readOnly">
            <!-- Name -->
            <div class="mb-4">
              <h4>{{ 'audio_name' | translate }}</h4>
              <div>{{ audio.props.name }}</div>
            </div>
            <!-- /Name -->
          </div>
          <div class="col-12 col-md-6" *ngIf="readOnly">
            <!-- Lang -->
            <div class="mb-4">
              <h4>{{ 'audio_lang' | translate }}</h4>
              <div *ngIf="audio.langExists()">
                <a [routerLink]="[
										'/language',
										audio.props.lang.getId()
									]">
                  {{ audio.props.lang.getLabel() }}
                </a>
              </div>
            </div>
            <!-- /Lang -->
          </div>
        </div>
      </div>
    </nz-card>
  </div>
</form>
